import { Component, Input, OnChanges, SimpleChanges, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { Animations } from '@fi-shared/utils/animations';
import { BehaviorSubject } from 'rxjs';
import { fiDebounce } from '@fi-shared/utils';

@Component({
    selector: 'fi-large-post-bubble',
    templateUrl: './large-post-bubble.component.html',
    styleUrls: ['./large-post-bubble.component.scss'],
    animations: [Animations.enterState()],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LargePostBubbleComponent implements OnChanges {
    @Input() content;
    showBubble = new BehaviorSubject<boolean>(false);

    private maxLength: number = 300;
    private bubbleDisplayTime = 30000;
    private timeout;

    private oldLength: number = 0;

    @HostListener('document:click')
    bodyClick(e) {
        this.resetBubble();
    }

    private resetBubble() {
        this.showBubble.next(false);
        if (this.timeout) clearTimeout(this.timeout);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes.content;
        if (change) this.checkContent();
    }

    private checkContent = fiDebounce(() => {
        const element = document.createElement('DIV');
        element.innerHTML = this.content;
        const text = element.innerText || element.textContent;
        const newLength = text.length;

        if (this.oldLength <= this.maxLength && newLength > this.maxLength) {
            this.showBubble.next(true);
            this.timeout = setTimeout(() => this.resetBubble(), this.bubbleDisplayTime);
        } else if (this.oldLength > this.maxLength && newLength <= this.maxLength) {
            this.resetBubble();
        }
        this.oldLength = newLength;
    }, 500);
}
